import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { EngineerJobItemType } from "../foundation.enums";
import { IEngineerCommission, IProcessResult } from "../foundation.interfaces";
import { IEngineerCommissionQueryOptions } from "../_models/IEngineerCommissionQueryOptions";

@Injectable({
    providedIn: 'root'
})
export class EngineerCommissionService {

    constructor(private readonly http: HttpClient) { }

    getEngineerCommissions(options: IEngineerCommissionQueryOptions = {}): Observable<IEngineerCommission[]> {
        return this.http.get<IEngineerCommission[]>(`/api/foundation/engineerCommissions/`, { params: options as HttpParams });
    }


    getEngineerCommission(commissionId: number): Observable<IEngineerCommission> {
        return this.http.get<IEngineerCommission>(`/api/foundation/engineerCommissions/${commissionId}`).pipe(map(commission => {
            commission.VisitReason = EngineerJobItemType[commission.VisitReasonId] ?? null;
            return commission;
        }));       
    }

    getEngineerCommissionsForCustomer(customerId: number, dateFrom: Date, dateTo: Date): Observable<IEngineerCommission[]> {
        const params: IEngineerCommissionQueryOptions = {
            Start: dateFrom.toISOString(),
            End: dateTo.toISOString(),
            AccountId: customerId
        }
        return this.http.get<IEngineerCommission[]>(`/api/foundation/engineerCommissions/`, { params: params as HttpParams });
    }

    createUpdateEngineerCommission(engineerCommission: IEngineerCommission): Observable<IProcessResult> {
        return this.http.post<IProcessResult>(`/api/foundation/engineerCommissions/`, engineerCommission);
    }

    processCommissionMappings(engineerCommission: IEngineerCommission): Observable<IProcessResult> {
        return this.http.post<IProcessResult>(`/api/foundation/engineerCommissions/processmappings/`, engineerCommission).pipe(map(mappingResult => {


            return mappingResult;
        }));
    }

}
